export default __webpack_public_path__ + "static/media/PAFI_Pemanggilan RUPS 2022.b757bf2a.pdf";